<template>
  <div>
    <el-result icon="info" sub-title="We're working on it." />
  </div>
</template>
<script>
export default {
  name: 'SwdWIPBlock',
}
</script>
